// Невозможно создать АБ тест для Профайл Б2С и передавать данные в скриптах АБ теста
export default {
  0: {
    imageAlt: 'автострахование',
    imageMobile: 'https://static.beeline.ru/upload/images/car_insurance_image_mobile.png',
    imageTablet: 'https://static.beeline.ru/upload/images/car_insurance_image_tablet.png',
    title: 'Экономьте на ОСАГО!',
    description: 'Сравните цены 18 страховых компаний онлайн, чтобы выбрать лучшую и сэкономить до 3000 рублей',
    notice: 'Подбор предложений по оформлению полиса осуществляется ООО «Сравни.ру»',
    buttonText: 'Сравнить цены',
    redirectUrl: 'https://www.sravni.ru/osago/wl/?uid=10e42c7c-e6f6-4e94-a7b0-db0b736dc92e&aff_id=2345&offer_id=1064&source=3263&aff_sub=9&aff_sub2=lkshpd&aff_sub3=link&aff_sub4=osago_alf&aff_sub5=clik1',
    backgroundColor: 'yellow',
  },
  1: {
    imageAlt: 'ипоточное страхование',
    imageMobile: 'https://static.beeline.ru/upload/images/credit_insurance_image_mobile.png',
    imageTablet: 'https://static.beeline.ru/upload/images/credit_insurance_image_tablet.png',
    title: 'Скидка 20% на ипотечное страхование!',
    description: 'Оформите страховой полис от АО «АльфаСтрахование» в Билайн и получите скидку 20%',
    notice: 'Услуга предоставляется АО «АльфаСтрахование» (лицензия СИ № 2239 от 13.11.2017 г.) . Рассчитать стоимость и узнать подробные условия страхования можно на сайте, нажав кнопку «Рассчитать цену»."',
    buttonText: 'Рассчитать стоимость',
    redirectUrl: 'https://beeline.alfastrah.ru/?utm_source=lkshpd&utm_medium=link&utm_campaign=ipoteka_alf&utm_term=clik3',
    backgroundColor: 'blue',
  },
  2: {
    imageAlt: 'страхование имущества',
    imageMobile: 'https://static.beeline.ru/upload/images/home_insurance_image_mobile.png',
    imageTablet: 'https://static.beeline.ru/upload/images/home_insurance_image_tablet.png',
    title: 'Затопили соседи?',
    description: 'Защитим вашу квартиру, дом или дачу. Быстро, онлайн и только то, что вам нужно. Рассчитайте свой полис прямо сейчас.',
    notice: 'Услугу предоставляет АО "АльфаСтрахование"',
    buttonText: 'Рассчитать стоимость',
    redirectUrl: 'https://alfa.beeline.ru/insurance/home?utm_source=lkshpd&utm_medium=link&utm_campaign=nedviz_alf&utm_term=clik2',
    backgroundColor: 'blue',
  },
  3: {
    imageAlt: 'страхование мобильного телефона',
    imageMobile: 'https://static.beeline.ru/upload/images/phone_insurance_image_mobile.png',
    imageTablet: 'https://static.beeline.ru/upload/images/phone_insurance_image_tablet.png',
    title: 'Страховка экрана дешевле ремонта',
    description: 'Защитите себя от лишних расходов, а смартфон — от неквалифицированного ремонта — оформите защиту экрана от 20 руб/мес. онлайн.',
    notice: 'Прочитать подробные условия и ограничения, а также оформить полис можно на сайте — нажмите кнопку «Оформить полис». Услугу предоставляет АО «АльфаСтрахование» (лицензия СИ № 2239 от 13.11.2017 г.)."',
    buttonText: 'Рассчитать стоимость',
    redirectUrl: 'https://alfa.beeline.ru/insurance/phone?utm_source=lkshpd&utm_medium=link&utm_campaign=screen_alf&utm_term=clik4',
    backgroundColor: 'yellow',
  },
};
